import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../authentication.service';

@Component({
  selector: 'app-menu',
  providers: [AuthenticationService],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  role;

  toggle: any = {};
  toggle1: any = {};
  constructor(private _service:AuthenticationService) { }

  ngOnInit() {
    this.role = localStorage.getItem("userrole");
  //  alert(this.role);
  }

  

  logout() {
    this._service.logout();
}

}
